import { ArbeitnehmerTyp } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitnehmerTyp';
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';

export class Mitarbeiter {
  constructor({
    id,
    vorname,
    nachname,
    imgUrl,
    arbeitnehmerTyp,
    arbeitsbereich,
    standort,
  }: {
    id: string;
    vorname: string;
    nachname: string;
    arbeitnehmerTyp?: ArbeitnehmerTyp;
    imgUrl?: string;
    arbeitsbereich?: Arbeitsbereich;
    standort: Standort;
  }) {
    this.id = id;
    this.vorname = vorname;
    this.nachname = nachname;
    this.imgUrl = imgUrl;
    this.arbeitnehmerTyp = arbeitnehmerTyp;
    this.arbeitsbereich = arbeitsbereich;
    this.standort = standort;
  }

  id: string;
  vorname: string;
  nachname: string;
  arbeitnehmerTyp?: ArbeitnehmerTyp;
  imgUrl?: string;
  arbeitsbereich?: Arbeitsbereich;
  standort: Standort;

  getName(): string {
    return this.vorname + ' ' + this.nachname;
  }

  getInitials(): string {
    return this.vorname[0] + this.nachname[0];
  }
}
